import * as React from 'react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { automations } from 'modules/automations/store/collections/automations'
import { triggers } from 'modules/automations/store/collections/triggers'
import type { Trigger } from 'modules/automations/store/models/Trigger'

interface CreateAutomationParams {
  name: string
  trigger: string
  company_id: string
}

export function useCreateAutomation() {
  const { running, performAction } = useAsyncAction((params: CreateAutomationParams) =>
    automations.create(params)
  )

  return [running, performAction] as const
}

const notShowLegacyContractTriggers = (models: Trigger[]): Trigger[] =>
  models.filter((model) => !model.isDeprecated)

export function useTriggers() {
  const { loading } = useAsyncData(() => triggers.fetch(), [])
  const [search, setSearch] = React.useState<string>('')
  const triggersArr = search ? triggers.filterBySlug(search) : triggers.models

  return [loading, notShowLegacyContractTriggers(triggersArr), search, setSearch] as const
}
